import { render, staticRenderFns } from "./Confirmar.vue?vue&type=template&id=6f2bbf39&scoped=true"
import script from "./Confirmar.vue?vue&type=script&lang=js"
export * from "./Confirmar.vue?vue&type=script&lang=js"
import style0 from "./Confirmar.vue?vue&type=style&index=0&id=6f2bbf39&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2bbf39",
  null
  
)

export default component.exports